// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import Fragment from 'vue-fragment';
import axios from 'axios';
import $ from 'jquery';
import 'jquery-ui'; // used by autocomplete
import BootstrapVue from 'bootstrap-vue';
// Next import is required for old-style bootstrap to be interactive (tabs, menus, etc.)
// and depends on jQuery being installed, which BootstrapVue doesn't use.
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// added VueGtag 2/6/22 - adds GA tracking to app
import VueGtag from 'vue-gtag';

import store from './store';

// Global styles
import '@/assets/css/styles.css';

// Global predictive array
import predictiveArray from './assets/data/predictivesource.json';

Vue.config.productionTip = false;
Vue.use(Fragment.Plugin);
Vue.use(BootstrapVue);

// config and use VueGtag with ID provided by DanD.
Vue.use(
   VueGtag,
   {
      config: {id: 'G-V8G5DDLVCX'},
      appName: 'CareerPathfinder',
      pageTrackerScreenviewEnabled: true,
   },
   router
);

Vue.prototype.$apiGet = function(url) {
   return axios.get(`${process.env.API_URL}${url}`);
};

Vue.prototype.$apiPost = function(url, body) {
   console.log('posting to', `${process.env.API_URL}${url}`);
   axios
      .post(`${process.env.API_URL}${url}`, body, {
         headers: {
            'Content-Type': 'application/json',
         },
      })
      .then(function(response) {
         console.log('response', response);
      })
      .catch(function(error) {
         console.log('error', error);
      });
   // return axios.post(`${process.env.API_URL}${url}`, body);
};

// make the predicitive array global
Vue.prototype.$predictiveArray = function() {
   return predictiveArray;
};

Vue.directive('popover', {
   inserted: function(el) {
      $(el).popover({
         boundary: 'window',
         container: 'body',
         sanitize: true,
         appendToBody: true,
      });
   },
});

/* eslint-disable no-new */
const root = new Vue({
   el: '#app',
   router,
   components: {App},
   template: '<App/>',
   store,
});

// https://www.npmjs.com/package/prerender-spa-plugin#js-not-firing-before-prerender
document.addEventListener('DOMContentLoaded', function() {
   root.$mount('#app');
});



// WEBPACK FOOTER //
// ./src/main.js